import React from 'react'

import ConnectedDocuments from '../../connectors/ConnectedDocuments/ConnectedDocuments'

const Documents = () => (
    <ConnectedDocuments />
)

export default Documents
